import * as React from "react";
const SvgIcTriangleUp = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19.9978 16L4.00079 16L11.9998 6L19.9978 16Z" fill="currentColor" /></svg>;
export default SvgIcTriangleUp;